import { useState } from "react";

interface UseSetActions<T> {
  add: (value: T) => void;
  clear: () => void;
  remove: (value: T) => void;
  reset: () => void;
}

export const useSet = <T>(
  initialValue: Set<T> = new Set<T>(),
): [Set<T>, UseSetActions<T>] => {
  const [set, setSet] = useState(initialValue);

  const add = (value: T): void => {
    setSet(set => {
      if (set.has(value)) {
        return set;
      }
      const newSet = new Set(set);
      newSet.add(value);
      return newSet;
    });
  };

  const remove = (value: T): void => {
    setSet(set => {
      const newSet = new Set(set);
      newSet.delete(value);
      return newSet;
    });
  };

  const clear = (): void => {
    setSet(() => new Set<T>());
  };

  const reset = (): void => {
    setSet(() => initialValue);
  };

  return [set, { add, remove, reset, clear }];
};
